import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { countries } from "../../global/countriesAndSources";
import { fetchIgoById } from "../../HTTP/countries";
import ForumLatestArticle from "./ForumLatestArticle";
import "./HomeHub.css";

const getStoredIgo = (igoId) => {
  try {
    const igo = JSON.parse(sessionStorage.getItem("selected_igo") || "null");
    return String(igo?.id) === String(igoId) ? igo : null;
  } catch (error) {
    console.error("Impossible de lire l'OIG sélectionnée", error);
    return null;
  }
};

const getCountryNames = (countryList) =>
  String(countryList || "")
    .split(",")
    .map((code) => {
      const normalizedCode = code.trim();
      return countries.find((country) => country.code === normalizedCode)?.name || normalizedCode;
    })
    .filter(Boolean)
    .join(", ");

export default function IgoPresentation() {
  const { igoId } = useParams();
  const navigate = useNavigate();
  const [igo, setIgo] = useState(() => getStoredIgo(igoId));
  const [error, setError] = useState("");

  useEffect(() => {
    if (igo) return;

    let isMounted = true;
    const loadIgo = async () => {
      try {
        const response = await fetchIgoById(igoId);
        const result = response?.data || response;
        if (!result || Array.isArray(result) || !result.id) {
          throw new Error("OIG introuvable");
        }
        if (isMounted) setIgo(result);
      } catch (loadError) {
        console.error("Erreur lors du chargement de l'OIG", loadError);
        if (isMounted) setError("Cette OIG n'a pas pu être chargée.");
      }
    };

    loadIgo();
    return () => {
      isMounted = false;
    };
  }, [igo, igoId]);

  const openTool = (path) => {
    if (!igo) return;

    sessionStorage.setItem("selected_igo", JSON.stringify(igo));
    sessionStorage.setItem("search_igo", igo.name);
    sessionStorage.setItem(
      "search_query",
      `${String(igo.link || "").replace(/^(https?:\/\/)?(www\.)?/i, "").replace(/\/$/, "")} `
    );
    sessionStorage.setItem(
      "search_country",
      JSON.stringify(countries.find((country) => country.code === "wd"))
    );
    navigate(path);
  };

  if (error) {
    return <div className="home-hub-wrapper"><section className="home-hub-igo-card">{error}</section></div>;
  }

  if (!igo) {
    return <div className="home-hub-wrapper"><section className="home-hub-igo-card">Chargement de l'OIG...</section></div>;
  }

  return (
    <main className="home-hub-wrapper">
      <section className="home-hub-igo-card">
        {igo.image && (
          <img
            className="home-hub-igo-logo"
            src={igo.image}
            alt={`Logo ${igo.label || igo.name}`}
          />
        )}
        <div className="home-hub-igo-details">
          <p className="home-hub-eyebrow">Forum global</p>
          <h1>{igo.label || igo.name}</h1>
          {igo.country_list && (
            <p className="home-hub-igo-countries">Pays : {getCountryNames(igo.country_list)}</p>
          )}
          {igo.link && (
            <a className="home-hub-igo-link" href={igo.link} target="_blank" rel="noopener noreferrer">
              Site officiel
            </a>
          )}
        </div>
      </section>

      <section className="home-hub-actions" aria-label="Outils pour ce forum">
          <button
            type="button"
            className="home-hub-action-btn notranslate"
            translate="no"
            onClick={() => openTool("/search")}
          >
            Zemus Search
          </button>
          <button
            type="button"
            className="home-hub-action-btn notranslate"
            translate="no"
            onClick={() => openTool("/zemus-ia")}
          >
            Zemus IA
          </button>
      </section>

      <ForumLatestArticle initialForum={igo} />
    </main>
  );
}
